const languages = [
  { code: 'zh-TW', label: '繁體中文', shortLabel: '中' },
  { code: 'en', label: 'English', shortLabel: 'EN' },
  { code: 'ja-JP', label: '日本語', shortLabel: '日' },
  { code: 'zh-CN', label: '简体中文', shortLabel: '简' },
  { code: 'vi', label: 'Tiếng Việt', shortLabel: 'VI' },
]

export default languages
